// 🛡️ protection-layer.js – Absolute Add to Cart Security for Shopify
(function () {
  const isVerified = () => {
    return (
      document.cookie.includes('vdg_verified=1') ||
      sessionStorage.getItem('verified') === '1'
    );
  };

  // ✅ 1. Early Fetch Protection
  try {
    const originalFetch = window.fetch;
    window.fetch = async function (input, init) {
      const url = typeof input === 'string' ? input : input?.url || '';
      if (/\/cart\/add(\.js)?/.test(url) && !isVerified()) {
        console.warn('[⛔ Blocked fetch to /cart/add – Not verified]', url);
        return new Response(null, { status: 403 });
      }
      return originalFetch(input, init);
    };
    console.log('[🛡️ Fetch protection active]');
  } catch (e) {
    console.warn('[⚠️ Fetch override error]', e);
  }

  // ✅ 2. XMLHttpRequest Protection
  try {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._url = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      const url = this._url || '';
      if (/\/cart\/add(\.js)?/.test(url) && !isVerified()) {
        console.warn('[⛔ Blocked XHR to /cart/add – Not verified]', url);
        this.abort();
        return;
      }
      return originalSend.apply(this, args);
    };
    console.log('[🛡️ XHR protection active]');
  } catch (e) {
    console.warn('[⚠️ XHR override error]', e);
  }

  // ✅ 3. Shopify.addItem Protection
  try {
    if (window.Shopify?.addItem) {
      const originalAddItem = Shopify.addItem;
      Shopify.addItem = function (...args) {
        if (!isVerified()) {
          console.warn('[⛔ Blocked Shopify.addItem – Not verified]');
          return;
        }
        return originalAddItem.apply(this, args);
      };
      console.log('[🛡️ Shopify.addItem protection active]');
    }
  } catch (e) {
    console.warn('[⚠️ Shopify.addItem override error]', e);
  }

  // ✅ 4. Form Submit Protection
 try {
  function enableFormProtection() {
    if (!document.body) {
      // Περιμένουμε λίγο αν body δεν είναι έτοιμο
      return setTimeout(enableFormProtection, 50);
    }

    document.body.addEventListener(
      'submit',
      function (e) {
        const form = e.target;
        if (form.matches('form[action*="/cart/add"]') && !isVerified()) {
          e.preventDefault();
          console.warn('[⛔ Blocked unverified form submit]');
        }
      },
      true
    );

    console.log('[🛡️ Form submit protection active]');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableFormProtection);
  } else {
    enableFormProtection();
  }
} catch (e) {
  console.warn('[⚠️ Form protection error]', e);
}
})();
